export enum ProductionPermissions {
  ChProduction = "ChProduction",
  ChProdPolicies = "ChProdPolicies",
  ChEntryCorrection = "ChEntryCorrection",
  ChProdEntryApproval = "ChProdEntryApproval",
  ChProdReports = "ChProdReports",
  ChProdMedicalActive = "ChProdMedicalActive",
  ChProductionReadOnly = "ChProductionReadOnly",
  ViewAllBranchs = "ViewAllBranchs",
  ChAccessAllProducersProduction = "ChAccessAllProducersProduction",
  ChProductionAccessAllUsers = "ChProductionAccessAllUsers",
  ChChangeProducerComm = "ChChangeProducerComm",
  ChUpdateDeliveryStatus = "ChUpdateDeliveryStatus",
  ChHideCompanyCommission = "ChHideCompanyCommission",
  ChHideProducerCommission = "ChHideProducerCommission",
  ChUnLockProducerComb = "ChUnLockProducerComb",
  ChDeclarationAlert = "ChDeclarationAlert",
}
